const browser = {
  type: "", //打开设备类型     iOSMobile,AndroidMobile,Mac,Window,other
  openType: "", //打开App  微信,qq,浏览器，Pc等
  deviceType: ""
};
const telBrowser = {
  versions: {
    //移动终端浏览器版本信息
    trident: navigator.userAgent.indexOf("Trident") > -1, //IE内核
    presto: navigator.userAgent.indexOf("Presto") > -1, //opera内核
    webKit: navigator.userAgent.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
    gecko: navigator.userAgent.indexOf("Gecko") > -1 &&
      navigator.userAgent.indexOf("KHTML") == -1, //火狐内核
    mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: navigator.userAgent.indexOf("Android") > -1 ||
      navigator.userAgent.indexOf("Linux") > -1, //android终端或uc浏览器
    iPhone: navigator.userAgent.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
    iPad: navigator.userAgent.indexOf("iPad") > -1, //是否iPad
    webApp: navigator.userAgent.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
  },
  language: (
    navigator.browserLanguage || navigator.language
  ).toLowerCase()
};

function detectOS() {
  let sUserAgent = navigator.userAgent;
  let isWin =
    navigator.platform == "Win32" || navigator.platform == "Windows";
  let isMac =
    navigator.platform == "Mac68K" ||
    navigator.platform == "MacPPC" ||
    navigator.platform == "Macintosh" ||
    navigator.platform == "MacIntel";
  if (isMac) return "Mac";
  let isUnix = navigator.platform == "X11" && !isWin && !isMac;
  //			    if (isUnix) return "Unix";
  if (isUnix) return "Window";
  let isLinux = String(navigator.platform).indexOf("Linux") > -1;
  //			    if (isLinux) return "Linux";
  if (isLinux) return "Window";
  if (isWin) {
    let isWin2K =
      sUserAgent.indexOf("Windows NT 5.0") > -1 ||
      sUserAgent.indexOf("Windows 2000") > -1;
    if (isWin2K) return "Window";
    let isWinXP =
      sUserAgent.indexOf("Windows NT 5.1") > -1 ||
      sUserAgent.indexOf("Windows XP") > -1;
    if (isWinXP) return "Window";
    let isWin2003 =
      sUserAgent.indexOf("Windows NT 5.2") > -1 ||
      sUserAgent.indexOf("Windows 2003") > -1;
    if (isWin2003) return "Window";
    let isWinVista =
      sUserAgent.indexOf("Windows NT 6.0") > -1 ||
      sUserAgent.indexOf("Windows Vista") > -1;
    if (isWinVista) return "Window";
    let isWin7 =
      sUserAgent.indexOf("Windows NT 6.1") > -1 ||
      sUserAgent.indexOf("Windows 7") > -1;
    if (isWin7) return "Window";
  }
  return "other";
};

function initBrowser() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    browser.type = "iOSMobile";
  } else if (/(Android|Adr)/i.test(navigator.userAgent)) {
    browser.type = "AndroidMobile";
  } else {
    browser.type = detectOS();
  }
  if (telBrowser.versions.mobile) {
    //判断是否是移动设备打开。browser代码在下面
    let ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      browser.openType = "weixin"; //在微信中打开
    } else if (ua.match(/WeiBo/i) == "weibo") {
      browser.openType = "weibo"; //在新浪微博客户端打开
    } else {
      browser.openType = "MobileBrower"; //在手机浏览器打开
    }
  } else {
    browser.openType = "PcBrower"; //PC浏览器打开
  }
}
export function isIOS() {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
}

export function isAndroid() {
      return (
        navigator.userAgent.indexOf("Android") > 0 ||
        navigator.userAgent.indexOf("Adr") > -1
      );
}
export function inApp() {
      var ua = navigator.userAgent;
      if (ua.indexOf("NCFinance App") != -1) {
        return true;
      } else {
        return false;
      }
}
    
export function isAndroidAndNobrowser() {
  initBrowser();
  if (
    (browser.type == "AndroidMobile" &&
      browser.openType == "MobileBrower") ||
    browser.type == "other" ||
    browser.type == "Window" ||
    browser.type == "iOSMobile" ||
    browser.type == "Mac"
  ) {
    //安卓，浏览器平台打开||ios打开
    return false;
  } else {
    //安卓，非浏览器平台打开
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/api/browser.js